import { AxiosError } from 'axios';
import { useAtomValue } from 'jotai';

import { CustomFilterChip, CustomFilterProps } from '@creditornot/cbt-filter-chip';
import { RecommendationPreferencesResponse } from 'common/api-types/recommendations';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { ProductFamiliesFilter } from 'common/components/cookbook/filters/ProductFamiliesFilter/ProductFamiliesFilter';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { TimePeriod } from './TimePeriod';
import { selectedProductFamilyIdsAtom } from '../Recommendations/state';

type PreferencesProps = {
  error: AxiosError<RecommendationPreferencesResponse> | null;
  isPending: boolean;
  onProductFamiliesChange: (productFamilyIds: string[] | null) => void;
};

const ProductFamiliesPreferences = ({ onChange, value }: CustomFilterProps<string[]>) => (
  <ProductFamiliesFilter productFamilyIds={value} onProductFamiliesChange={onChange} />
);

export const Preferences = ({ isPending, onProductFamiliesChange }: PreferencesProps) => {
  const f = useFormatMessage();
  const selectedProductFamilyIds = useAtomValue(selectedProductFamilyIdsAtom);

  return (
    <ContentContainer borderBottom verticalPadding="sm">
      <Stack gap="regularMedium" direction="row" justifyContent="space-between">
        <CustomFilterChip
          data-test-id="product-families-filter-chip"
          label={f('common.product_family')}
          filterComponent={ProductFamiliesPreferences}
          menuInteraction={true}
          selected={selectedProductFamilyIds.length > 0}
          displaySelected="number"
          loading={isPending}
          selectedCount={selectedProductFamilyIds.length}
          onClearClick={() => {
            onProductFamiliesChange(null);
          }}
          value={selectedProductFamilyIds}
          onChange={onProductFamiliesChange}
        />

        <TimePeriod />
      </Stack>
    </ContentContainer>
  );
};
